@if (!hasSchedules()) {
  <div>
    @if (allowEdit) {
      <gymfinder-alert variant="light" class="alert-margin-top">
        There are no schedules, please create one.
      </gymfinder-alert>
    }
    @if (!allowEdit) {
      <gymfinder-alert variant="light" class="alert-margin-top">
        No schedules were executed yet.
      </gymfinder-alert>
    }
  </div>
}

@if (schedules && hasSchedules()) {
  <table mat-table [dataSource]="schedules" class="schedule-table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ displayName(element) }}</td>
    </ng-container>
    <ng-container matColumnDef="field">
      <th mat-header-cell *matHeaderCellDef>Field</th>
      <td mat-cell *matCellDef="let element">{{ element.field }}</td>
    </ng-container>
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef>Value</th>
      <td mat-cell *matCellDef="let element">{{ displayValue(element) }}</td>
    </ng-container>
    <ng-container matColumnDef="scheduledAt">
      <th mat-header-cell *matHeaderCellDef>Scheduled</th>
      <td mat-cell *matCellDef="let element">{{ element.scheduledAt }}</td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          (click)="handleDeleteSchedule(element)"
          color="warn"
          matTooltip="Delete Schedule"
          *ngxPermissionsOnly="'editSchedules'">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="executedAt">
      <th mat-header-cell *matHeaderCellDef>Executed</th>
      <td mat-cell *matCellDef="let element">{{ element.executedAt }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
}
